import { AUTH_LOGOUT } from "./types";

export const actions = {
	[AUTH_LOGOUT]: ({ commit }) => {
		return new Promise((resolve, _reject) => {
			commit("resetState");
			// commit(AUTH_LOGOUT);
			resolve();
		});
	}
};